/** Сессия загрузки по UUID */
export class UploadParams {
  upload: string

  constructor({ upload }: { upload: string }) {
    this.upload = upload
  }
}
